export default class StyleHelper {
  private static gradientList: string[] = [
    '#FFE780, #EE490D',
    '#ABE8F5, #008480',
    '#FFA7A7, #4F17A8',
    '#FFC980, #C80029',
    '#ABE8F5, #43A83E',
    '#EC0030, #4F17A8',
    '#FFE780, #C80029',
    '#FFDD4D, #43A83E',
    '#ABE8F5, #441D82',
    '#FFC980, #FF9F00',
    '#ABE8F5, #255022',
  ];

  private static randomHex() {
    return (Math.floor(Math.random() * 200) + 50)
      .toString(16)
      .padStart(2, '0');
  }

  private static randomColor() {
    return `#${[...Array(3)].map(this.randomHex).join('')}`;
  }

  public static randomGradient():string {
    const color1 = this.randomColor();
    const color2 = this.randomColor();

    return `linear-gradient(135deg, ${color1}, ${color2})`;
  }

  public static getGradient(index: number): string {
    return this.gradientList[index % 11];
  }
}
